import 'bootstrap/dist/css/bootstrap.rtl.min.css';
import { useEffect } from 'react';

const Delivery = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])
    return (
        <>
            <section className="container py-5">
                <h1 className="text-center mb-5 h5">روش ارسال کالا در آکبند</h1>
                <div className="row justify-content-center">
                    <div className="col-md-10">
                        <div className="card rounded rounded-4 mb-4">
                            <div className="card-body">
                                <p className="text-muted">
                                    ما در آکبند تلاش می‌کنیم تا سفارش شما در کوتاه‌ترین زمان ممکن به دستتان برسد. به همین دلیل چند روش یا چند بازه زمانی برای ارسال سفارش‌ها در نظر گرفته‌ایم تا با توجه به شرایط خود، مناسب‌ترین گزینه را انتخاب کنید.
                                </p>
                            </div>
                        </div>
                        <div className="card mb-4 rounded rounded-4">
                            <div className="card-header bg-white">
                                <h2 className="h5 fw-bold py-2 mb-0">ارسال توسط پیک موتوری در سطح تهران و تبریز</h2>
                            </div>
                            <div className="card-body">
                                <ul>
                                    <li className="mb-2 line-30">پیک موتوری آکبند، تمامی مناطق ۲۲گانه تهران و مناطق ۱۰گانه تبریز امکان ارسال دارد.</li>
                                    <li className="mb-2 line-30">در روزهای جمعه و تعطیلات رسمی، ارسال سفارش امکان‌پذیر نیست.</li>
                                    <li className="mb-2 line-30">هزینه ارسال از طریق پیک موتوری، وابسته به موقعیت مکانی محل تحویل سفارش متغیر می‌باشد.</li>
                                    <li className="mb-2 line-30">ارائه کارت شناسایی در زمان تحویل کالا از سوی خریدار یا تحویل‌گیرنده‌ای که مشخصات او در جزئیات ثبت سفارش قید شده باشد، الزامی است.</li>
                                    <li className="mb-2 line-30">تحویل‌گیرنده سفارش موظف است بسته را در زمان دریافت بررسی کند و در صورت پلمپ بودن آن را تحویل بگیرد. در صورتی که پلمپ، باز یا مخدوش شده باشد، از تحویل گرفتن آن خودداری کنید و سریعاً با پشتیبانی آکبند تماس بگیرید.</li>
                                </ul>
                            </div>
                        </div>

                        <div className="card mb-4 rounded rounded-4">
                            <div className="card-header bg-white">
                                <h2 className="h5 fw-bold py-2 mb-0">ارسال از طریق تیپاکس، ماهکس و چاپار</h2>
                            </div>
                            <div className="card-body">
                                <ul>
                                    <li className="mb-2 line-30">امکان ارسال کالا از طریق تیپاکس، ماهکس و چاپار برای شهرهایی که تحت پوشش هستند، فراهم است.</li>
                                    <li className="mb-2 line-30">هزینه ارسال با توجه به مسافت طی‌شده، وزن و ارزش مرسوله توسط شرکت ارسال‌کننده (تیپاکس، ماهکس یا چاپار) محاسبه و به‌صورت لینک، جهت پرداخت برای تحویل‌گیرنده ارسال می‌شود.</li>
                                    <li className="mb-2 line-30">اکیداً توصیه می‌کنیم در زمان تحویل کالا، از مخدوش نبودن لیبل پلمپ مطمئن شوید. در صورتی که پلمپ مخدوش شده بود، بسته را تحویل نگیرید و فوراً با پشتیبانی آکبند تماس بگیرید.</li>
                                    <li className="mb-2 line-30">سفارش‌هایی که از طریق تیپاکس، ماهکس یا چاپار ارسال می‌شوند، در این مراکز بیمه می‌شوند. در صورتی که سفارش شما در فرایند ارسال با تیپاکس، ماهکس یا چاپار مفقود شود، پس از تایید مفقودی کالا توسط کارشناس شرکت مربوطه، هزینه توسط تیپاکس، ماهکس یا چاپار به شما عودت داده خواهد شد. توجه کنید که در این شرایط، جبران خسارت ناشی از مفقودی کالا به عهده شرکت ارسال‌کننده است و آکبند صرفاً پیگیری بازگشت وجه را انجام خواهد داد.</li>
                                </ul>
                            </div>
                        </div>

                        <div className="card mb-4 rounded rounded-4">
                            <div className="card-header bg-white">
                                <h2 className="h5 fw-bold py-2 mb-0">ارسال از طریق پست پیشتاز</h2>
                            </div>
                            <div className="card-body">
                                <ul>
                                    <li className="mb-2 line-30">امکان ارسال کالا برای سراسر کشور از طریق پست فراهم است. سفارش‌هایی که روش ارسال آن‌ها پست است، در روز کاری بعد از ثبت سفارش، ارسال خواهند شد.</li>
                                    <li className="mb-2 line-30">کد پیگیری مرسوله در قسمت جزئیات سفارش‌های حساب کاربری شما در سایت درج و همچنین از طریق پیامک نیز برایتان ارسال خواهد شد.</li>
                                    <li className="mb-2 line-30">در صورتی که سفارش شما در فرایند ارسال با پست پیشتاز مفقود شود، پس از تایید اداره پست مبنی بر مفقودی کالا، وجه پرداخت‌شده شما، توسط اداره پست عودت داده خواهد شد. توجه کنید که در این شرایط، جبران خسارت ناشی از مفقودی کالا به عهده اداره پست است و آکبند صرفاً پیگیری بازگشت وجه را انجام خواهد داد.</li>
                                </ul>
                            </div>
                        </div>

                        <div className="card mb-4 rounded rounded-4">
                            <div className="card-header bg-white">
                                <h2 className="h5 fw-bold py-2 mb-0">نکات قابل توجه</h2>
                            </div>
                            <div className="card-body">
                                <ul>
                                    <li className="mb-2 line-30">آکبند ممکن است در شرایط و روزهای خاص، ارسال سفارش را به‌صورت رایگان انجام دهد. برای اطلاع از تخفیف‌ها و جشنواره‌ها، صفحات آکبند در شبکه‌های اجتماعی را دنبال کنید.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Delivery;